import { gql } from 'apollo-boost';
import {
    HydratedComparisonField,
    HydratedCurriculumType,
} from '../Common/types/AppConfigTypes';
import { Field, FieldType } from '../Common/types/CatalogTypes';

interface ComparisonQueryOpts {
    curriculumType: HydratedCurriculumType;
    selectedUuids: string[];
}

export const comparisonQuery = ({
    curriculumType,
    selectedUuids,
}: ComparisonQueryOpts) => {
    if (!curriculumType) {
        console.error('Cannot query list without active curriculum type.');
        return;
    }

    const { name, comparisonFields } = curriculumType.comparisonView;

    const queries = selectedUuids.map((uuid, index) => {
        return `
        selected${index}: ${curriculumType.contentType.slug} (uuid: "${uuid}") {
            uuid
            ${name.field.slug}
            ${comparisonFields
                .map(comparisonField => {
                    const isSameContentType =
                        comparisonField.contentType.uuid ===
                        curriculumType.contentType.uuid;

                    return isSameContentType
                        ? comparisonField.field.slug
                        : buildQueryFieldForLinkFields(
                              curriculumType,
                              comparisonField,
                          );
                })
                .join('\n')}
        }
    `;
    });

    return gql`{   
        ${queries.join('\n')}
    }`;
};

const buildQueryFieldForLinkFields = (
    curriculumType: HydratedCurriculumType,
    comparisonField: HydratedComparisonField,
) => {
    const matchingFieldOnCurriculumType = curriculumType.contentType.fields.find(
        (field: Field) => {
            if (!field || !field.controls) {
                console.error('Error building graphql query for link field');
                return '';
            }

            const { fieldType, linkUuid } = field.controls;

            const isLinkField =
                fieldType === FieldType.SingleLink ||
                fieldType === FieldType.MultiLink;

            return isLinkField && linkUuid === comparisonField.contentType.uuid;
        },
    );

    if (matchingFieldOnCurriculumType) {
        return `${matchingFieldOnCurriculumType.slug} {
            ${comparisonField.field.slug}
        }`;
    }
};

export const pageQuery = ({ selectedUuids }: { selectedUuids: string[] }) => {
    const pageQueries = selectedUuids.map((uuid, index) => {
        return `
        page${index}: pageByContentRevision(contentRevisionUuid: "${uuid}") {
            path
            catalogContentRevisionUuid
        }
        `;
    });

    return gql`{
        ${pageQueries.join('\n')}
    }`;
};

interface SelectedLabelsQueryOpts {
    curriculumType: HydratedCurriculumType;
    selectedUuids: string[];
}

export const selectedLabelsQuery = ({
    curriculumType,
    selectedUuids,
}: SelectedLabelsQueryOpts) => {
    if (!curriculumType) {
        console.error('Cannot query list without active curriculum type.');
        return;
    }

    const { name } = curriculumType.comparisonView;

    const queries = selectedUuids.map((uuid, index) => {
        return `selected${index}: ${curriculumType.contentType.slug} (uuid: "${uuid}") {
            uuid
            ${name.field.slug}
        }`;
    });

    return gql`{   
        ${queries.join('\n')}
    }`;
};
